import Plotly from "plotly.js-basic-dist-min";
import plotComponentFactory from "react-plotly.js/factory";

export const PlotComponent = plotComponentFactory(Plotly);
